import { trace } from '@opentelemetry/api';
import pkg from '../../package.json';

export const useTrace = () => trace.getTracer(pkg.name, pkg.version);
